import dayjs, { Dayjs } from 'dayjs';

export const getToday = (): Dayjs => {
  const t = new Date();
  const y = t.getFullYear().toString().padStart(4, '0');
  const m = (t.getMonth() + 1).toString().padStart(2, '0');
  const d = t.getDate().toString().padStart(2, '0');
  return dayjs(new Date(`${y}-${m}-${d}`));
};
